import { Box, Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useErroredEmployeesDataTable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import MissingAlert from '../missingAlert'

interface Props {
  employeeImportId: number
}

const ErroredEmployees = ({ employeeImportId }: Props) => {
  const erroredEmployees = useErroredEmployeesDataTable(
    [
      {
        identifier: 'first_name',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.first_name'),
        template: `{{ importedEmployee.mandatoryData_firstName }}`,
        render: (importedEmployee) => {
          if (importedEmployee.mandatoryData_firstName !== null) {
            return (
              <Text.Normal size="300" ellipsis>
                {importedEmployee.mandatoryData_firstName}
              </Text.Normal>
            )
          } else {
            return <MissingAlert />
          }
        },
      },
      {
        identifier: 'last_name',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.last_name'),
        template: `{{ importedEmployee.mandatoryData_lastName }}`,
        render: (importedEmployee) => {
          if (importedEmployee.mandatoryData_lastName !== null) {
            return (
              <Text.Normal size="300" ellipsis>
                {importedEmployee.mandatoryData_lastName}
              </Text.Normal>
            )
          } else {
            return <MissingAlert />
          }
        },
      },
      {
        identifier: 'email',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.email'),
        template: `{{ importedEmployee.mandatoryData_email }}`,
        render: (importedEmployee) => {
          if (importedEmployee.mandatoryData_email !== null) {
            return (
              <Text.Normal size="300" ellipsis>
                {importedEmployee.mandatoryData_email}
              </Text.Normal>
            )
          } else {
            return <MissingAlert />
          }
        },
      },
      {
        identifier: 'datev_employee_code',
        kind: ProjectionKind.Custom,
        title: i18n.t(
          'payroll_integrations.incidences.datev_lauds.import.table.datev_employee_code'
        ),
        template: `{{ importedEmployee.mandatoryData_datevEmployeeCode }}`,
        render: (importedEmployee) => {
          if (importedEmployee.mandatoryData_datevEmployeeCode !== null) {
            return (
              <Text.Normal size="300" ellipsis>
                {importedEmployee.mandatoryData_datevEmployeeCode}
              </Text.Normal>
            )
          } else {
            return <MissingAlert />
          }
        },
      },
      {
        identifier: 'legal_entity_name',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.legal_entity'),
        template: `{{ importedEmployee.mandatoryData_legalEntityName }}`,
        render: (importedEmployee) => {
          if (importedEmployee.mandatoryData_legalEntityName !== null) {
            return (
              <Text.Normal size="300" ellipsis>
                {importedEmployee.mandatoryData_legalEntityName}
              </Text.Normal>
            )
          } else {
            return <MissingAlert />
          }
        },
      },
    ],
    {
      variables: { employeeImportId: employeeImportId, employeeType: 'errored_employees' },
    }
  )

  return (
    <Box
      position="sticky"
      style={{
        bottom: '0',
      }}
      maxHeight="s400"
    >
      <DataTable
        source={erroredEmployees}
        disableDefaultActions
        pagination={{
          kind: 'offset',
          itemsPerPage: 20,
        }}
      />
    </Box>
  )
}

export default ErroredEmployees
